export default __webpack_public_path__ + "static/media/envelope.b20b1a9d.svg";